import React from "react";
import BranchDashboardPage from "./BranchDashboardPage";

export default function RiyadhPage() {
  return (
    <BranchDashboardPage branch="riyadh" />
  );
}